import axios from 'axios';
import product from './product';

export default {
    fetchExportableProducts() {
        return axios.post('/validateProducts/fetchExportableProducts');
    },
    validateProducts(productIds) {
        return axios.post('/validateProducts/validateProducts', { productIds });
    },
};
